import { useEffect, useRef, useState } from 'react';
import { Box, HStack, Text, VStack, useMediaQuery } from 'native-base';
import CryptoJS from 'crypto-js';
import WebHeader from '../../layout/header/webHeader';
import { COLORS } from '../../utils/colors';
import TravelPartners from './modalChildren/travelPartners';
import PoliciesDocuments from './modalChildren/policies';
import MobileHeader from '../../layout/header/mobileHeader';
import WalletListing from './modalChildren/walletListing';
import CustomButton from '../../components/button';
import { filterSVG, uploadWalletIconSVG } from '../../utils/svg';
import CustomModal from '../../components/modal';
import { TravelWallet } from './modalChildren/walletListing/modalChildren';
import { MOBILE_VIEW_WIDTH } from '../../utils/screens';
import CommonAvatar from '../../components/avatar';
import Breadcrumbs from '../../components/breadcrumb';
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from '../../utils/fonts';
import { uploadFileAPI } from '../../api/apis/workflow';
import { Toaster } from '../../components/toaster';
import NewImagesListingQuickLink from './modalChildren/images_new';
import NewReviewList from './modalChildren/review_new';
import { uploadWalletsAPI } from '../../api/apis/quicklinks';
import { useSelector } from 'react-redux';
import { getNotificationAPI } from '../../api/apis/notification';
import MobileModelSheet from '../../components/actionSheet';
import { LoaderAnimation } from '../../components/spinner';
import PopOverModal from '../../components/popover';
import Svg from 'react-native-svg';
import Charts from '../charts';
import { addIconSVG, dashboardSVG } from '../../utils/svg';
import DateInputField from '../../components/dateInput';
import config from '../../utils/config';
import EventPartnerModal from './modalChildren/createPartnerModal';
import { addTravelPartnerAPI } from '../../api/apis/quicklinks';
import { hasPermission } from '../../utils/permission';
import UsersListing from './modalChildren/users_listing';
import UserAccessRequests from './modalChildren/users_access_requests';
import QuotationRequests from './modalChildren/quotation_requests';
import SurveyForm from './modalChildren/surveyForm';
import SurveyFormModal from './modalChildren/surveyForm/SurveyFormModal';
import ArchiveFolderQuickLink from './modalChildren/archiveFolder';
import BenchmarkData from './modalChildren/benchmarkData';

const QuickLinksDetailsPage = ({ ...props }) => {
  const childRef = useRef(null);
  const childref = useRef(null);
  const ref = useRef(null);
  const toaster = Toaster();
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH
  });
  const [options, setOptions] = useState({
    types: [{ name: 'General', value: 'general', selected: '' }],
    selected: ''
  });
  const [showModal, setShowModal] = useState(false);
  const [showPartnerModal, setShowPartnerModal] = useState(false);
  const [showSurveyModal, setShowSurveyModal] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0); // Add refresh trigger
  const selectedLink = props.link_type;
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem('content'),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const [selectedOption, setSelectedOption] = useState('general_' + activeTab);
  const [selectedValue, setSelectedValue] = useState({
    type: '',
    event: '',
    document_name: '',
    documents: ''
  });
  const [forceRemount, setForceRemount] = useState(false);
  const [walletData, setWalletData] = useState(false);
  const eventTab = activeTab === 'event' ? 'Event' : 'MICE';

  const getDateChange = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');
    // setDate({ ...date, to_date: `${year}-${month}-${day}` });
    return `${year}-${month}-${day}`;
  };

  const [date, setDate] = useState({
    from_date: '2020-01-01',
    to_date: getDateChange()
  });

  useEffect(() => {
    let option = { ...options };
    if (activeTab === 'mice' && option.types.length <= 1) {
      option.types.push({ name: 'MICE', value: 'mice', selected: '' });
    } else if (activeTab === 'mice' && option.types.length === 2) {
      option.types.pop();
      option.types.push({ name: 'MICE', value: 'mice', selected: '' });
    }
    if (activeTab === 'event' && option.types.length <= 1) {
      option.types.push({ name: 'Event', value: 'event', selected: '' });
    } else if (activeTab === 'event' && option.types.length === 2) {
      option.types.pop();
      option.types.push({ name: 'Event', value: 'event', selected: '' });
    }
    option.selected = '';
    setOptions(option);
    setSelectedOption('general_' + activeTab);
    setDate({
      from_date: '2020-01-01',
      to_date: getDateChange()
    });

    setSelectedValue({
      ...selectedValue,
      type: '',
      event: '',
      document_name: ''
    });
  }, [activeTab]);

  const openModal = () => {
    setForceRemount(!forceRemount);
    setShowModal(true);
  };

  const closeModal = () => {
    setForceRemount(!forceRemount);
    setSelectedValue({ type: '', event: '', document_name: '', documents: '' });
    setShowModal(false);
  };

  const getStartDateFormat = (dateString) => {
    const date = new Date(dateString);
    function padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    }
    function formatDate(date) {
      return (
        [
          date.getFullYear(),
          padTo2Digits(date.getMonth() + 1),
          padTo2Digits(date.getDate())
        ].join('-') +
        'T' +
        [
          padTo2Digits(date.getHours()),
          padTo2Digits(date.getMinutes()),
          padTo2Digits(date.getSeconds())
        ].join(':') +
        '.' +
        '616838+00:00'
      );
    }
    const formattedDate = formatDate(date);

    return formattedDate;
  };

  const uploadFilesToServer = async (data, type, upload_type) => {
    let docs = [];
    if (type === 'documents') {
      let res = await uploadFileAPI(data, type, upload_type);

      res.map((item) => {
        if (item.error) {
          toaster('Upload file failed', 'error', 'error');
          return;
        }
        if (item.data.data.data) {
          docs.push({
            doc_type: item.data.data.data.doc_type,
            file_size: item.data.data.data.file_size.toString(),
            file_name: item.data.data.data.file_name,
            uploaded_time: getStartDateFormat(new Date())
          });
        }
      });
    }
    return docs;
  };

  // Enhanced refresh function for travel partners
  const refreshTravelPartnersList = () => {
    if (selectedLink === 'TRAVEL_PARTNER') {
      setRefreshTrigger((prev) => prev + 1);
      // Also try to call the refresh method if it exists
      if (childRef.current && childRef.current.refreshTravelPartners) {
        childRef.current.refreshTravelPartners();
      }
      // Alternative: if there's a getData method
      if (childRef.current && childRef.current.getData) {
        childRef.current.getData();
      }
      // Alternative: if there's a fetchTravelPartners method
      if (childRef.current && childRef.current.fetchTravelPartners) {
        childRef.current.fetchTravelPartners();
      }
    }
  };

  const handleTravelPartnerSubmit = async (partnerData) => {
    try {
      LoaderAnimation.show();
      // Call the add travel partner API
      const response = await addTravelPartnerAPI(partnerData, activeTab);
      if (response.error) {
        toaster(
          response.message || 'Failed to create travel partner',
          'error',
          'error'
        );
      } else {
        toaster(
          response.data.data.message || 'Travel partner created successfully',
          'success',
          'success'
        );
        // Close the modal
        setShowPartnerModal(false);
        // Enhanced refresh logic - try multiple approaches
        setTimeout(() => {
          refreshTravelPartnersList();
        }, 100); // Small delay to ensure modal closes first
      }
    } catch (error) {
      console.error('Error creating travel partner:', error);
      toaster('Error creating travel partner', 'error', 'error');
    } finally {
      LoaderAnimation.hide();
    }
  };

  const modalHeader = <Text>Add Travel Wallet</Text>;
  const modalFooter = (
    <Box width={MobileWindow && '100%'}>
      <CustomButton
        text='Update'
        width={MobileWindow ? '100%' : 'auto'}
        onPress={async () => {
          LoaderAnimation.show();
          let value = childref.current.onSubmitDataInput();
          setSelectedValue(value);
          if (
            value.document_name !== '' &&
            (value.document_name.length < 3 ||
              !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
                value.document_name
              ))
          ) {
            toaster('Pleae enter proper Document Name', 'error', 'error');
          } else if (value.document_name.length > 500) {
            toaster(
              'Please enter Document Name less than 500 characters',
              'error',
              'error'
            );
          } else if (
            value.type &&
            (value.type === 'event' || value.type === 'mice'
              ? value.event
              : !value.event) &&
            value.document_name
          ) {
            if (value.documents.length > 0) {
              let docs = await uploadFilesToServer(
                value.documents,
                'documents',
                'wallet'
              );
              let payload = {
                type: value.type,
                event_id: value.event,
                document_name: value.document_name,
                added_by: userInfo.email,
                file_name: docs[0].file_name,
                documents: docs
              };
              let res = await uploadWalletsAPI(payload);
              if (res.error) {
                toaster(res.message, 'error', 'error');
                LoaderAnimation.hide();
                return;
              } else {
                toaster('Uploaded Successfully', 'success', 'success');
                childRef.current.getWalletListing();
                closeModal();
              }
            } else toaster('Upload a document', 'error', 'error');
          } else toaster('Enter all details', 'error', 'error');
          LoaderAnimation.hide();
        }}
      />
    </Box>
  );

  const handleBreadCrumb = () => {
    if (selectedLink === 'POLICIES_DOCUMENTS')
      return { name: 'Policies & Documents', path: '/policy' };
    else if (selectedLink === 'TRAVEL_PARTNER')
      return { name: 'Travel Partner', path: '/travel-partners' };
    else if (selectedLink === 'IMAGES')
      return { name: 'Images', path: '/images' };
    else if (selectedLink === 'REVIEWS')
      return { name: 'Reviews', path: '/reviews' };
    else if (selectedLink === 'WALLET')
      return { name: 'Wallet', path: '/wallets' };
    else if (selectedLink === 'DASHBOARD')
      return { name: 'Dashboard', path: '/dashboard' };
    else if (selectedLink === 'USERS_LISTING')
      return { name: 'Users Listing', path: '/users' };
    else if (selectedLink === 'USER_ACCESS_REQUESTS')
      return { name: 'User Access Requests', path: '/user-access-requests' };
    else if (selectedLink === 'QUOTATION_REQUESTS')
      return { name: 'Quotation requests', path: '/quotation-requests' };
    else if (selectedLink === 'SURVEY_FORM')
      return { name: 'Survey Form', path: '/survey-forms' };
    else if (selectedLink === 'ARCHIVE_FOLDER')
      return { name: 'Archive Folder', path: '/archive-folder' };
    else if (selectedLink === 'BENCHMARK_DATA')
      return { name: 'Benchmark Data', path: '/benchmark-data' };
  };

  const breadcrumbDetails = {
    activeTab: { name: 'Home', path: '/home' },
    activeMenu: handleBreadCrumb(),
    activeActivePage: { name: '', path: '' }
  };

  const getDetailsChildren = () => {
    if (selectedLink === 'POLICIES_DOCUMENTS') return <PoliciesDocuments />;
    else if (selectedLink === 'TRAVEL_PARTNER')
      return (
        <TravelPartners
          ref={childRef}
          key={refreshTrigger}
        />
      );
    else if (selectedLink === 'IMAGES') return <NewImagesListingQuickLink />;
    else if (selectedLink === 'REVIEWS') return <NewReviewList />;
    else if (selectedLink === 'WALLET')
      return (
        <WalletListing
          selectedOption={selectedOption}
          ref={childRef}
          setWalletData={setWalletData}
          scrollToTop={scrollToTop}
        />
      );
    else if (selectedLink === 'DASHBOARD' && activeTab === 'event')
      return (
        <Charts
          activeTab={'event'}
          date={date}
          ref={ref}
        />
      );
    else if (selectedLink === 'DASHBOARD' && activeTab === 'mice')
      return (
        <Charts
          activeTab={'mice'}
          date={date}
          ref={ref}
        />
      );
    else if (selectedLink === 'USERS_LISTING') return <UsersListing />
    else if (selectedLink === 'USER_ACCESS_REQUESTS') return <UserAccessRequests />
    else if (selectedLink === 'QUOTATION_REQUESTS') return <QuotationRequests />
    else if (selectedLink === 'SURVEY_FORM') return <SurveyForm key={refreshTrigger} />;
    else if (selectedLink === 'ARCHIVE_FOLDER') return <ArchiveFolderQuickLink />;
    else if (selectedLink === 'BENCHMARK_DATA') return <BenchmarkData />;
  };

  const handleShowTabs = () => {
    if (
      selectedLink === 'TRAVEL_PARTNER' ||
      selectedLink === 'IMAGES' ||
      selectedLink === 'REVIEWS' ||
      selectedLink === 'WALLET' ||
      selectedLink === 'DASHBOARD' ||
      selectedLink === 'ARCHIVE_FOLDER')
      return true;
    else return false;
  };

  const textTransform = (text) => {
    if (text === 'POLICIES_DOCUMENTS') text = 'POLICIES & DOCUMENTS';
    else if (text === 'TRAVEL_PARTNER') return `${eventTab} Partner`;
    else if (text === 'USERS_LISTING') return 'Users Listing';
    else if (text === 'USER_ACCESS_REQUESTS') return 'User Access Requests';
    else if (text === 'QUOTATION_REQUESTS') return 'Quotation Requests';
    else if (text === 'SURVEY_FORM') return 'Survey Form';
    else if (text === 'ARCHIVE_FOLDER') return 'Archive Folder';
    else if (text === 'BENCHMARK_DATA') return 'Benchmark Data';
    let correctText = text.toLowerCase();
    correctText = correctText.replace(/\b\w/g, (char) => char.toUpperCase());
    return correctText;
  };

  const getPopupChildren = () => {
    return options.types.map((item) => {
      return (
        <HStack
          space={1.5}
          key={item.value}
          className='radio-btns'
          pr={3}
          alignItems={'center'}
        >
          <input
            type='radio'
            value={item.value}
            checked={options.selected === item.value}
            onChange={(e) => {
              let option = { ...options };
              option.selected = e.target.value;
              setOptions(option);
            }}
            className='radio-btns'
          />
          <Text
            color={COLORS.PARTNERS_HEADING_COLOR}
            fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
            pt='13px'
            mb={2}
            width={'100%'}
          >
            {item.name}
          </Text>
        </HStack>
      );
    });
  };

  const onInputChange = (e, eName) => {
    let filterDate = { ...date };
    if (e.target.value) filterDate[eName] = e.target.value;
    else if (eName === 'from_date') filterDate[eName] = '2020-01-01';
    else if (eName === 'to_date') filterDate[eName] = getDateChange();
    setDate(filterDate);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Box
      bg={COLORS.THEME_BACKGROUND}
      pb={8}
      minHeight={'100vh'}
    >
      <Box bg={COLORS.WHITE_COLOR}>
        {MobileWindow ? (
          <MobileHeader
            showTabs={handleShowTabs()}
            quicklink='yes'
          />
        ) : (
          <>
            <WebHeader
              showTabs={handleShowTabs()}
              quicklink='yes'
            />
            <Box
              p={4}
              px={'5rem'}
            >
              <Breadcrumbs path={breadcrumbDetails} />
            </Box>
          </>
        )}
      </Box>
      <VStack
        pt={7}
        pr={MobileWindow ? '13px' : '4rem'}
        space={5}
        pl={MobileWindow ? '13px' : '5rem'}
      >
        {selectedLink === 'WALLET' ? (
          <HStack
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <Text
              fontSize={
                MobileWindow ? '22px' : COMMONFONTSIZE.HEADER_TEXT_FONT_SIZE
              }
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
            >
              Wallet
            </Text>
            <HStack space={2}>
              {walletData &&
                (!MobileWindow ? (
                  <Box
                    mt={4}
                    mr={3}
                  >
                    <PopOverModal
                      isOpen={showPopup}
                      onClose={() => {
                        setShowPopup(!showPopup);
                      }}
                      onOpenPress={() => {
                        setShowPopup(!showPopup);
                      }}
                      type='comments'
                      svg={
                        <Svg
                          width='24'
                          height='24'
                          viewBox='0 0 24 24'
                        >
                          {filterSVG}
                        </Svg>
                      }
                      body={getPopupChildren()}
                      footer={
                        <HStack
                          mb={3}
                          justifyContent={'space-between'}
                          width={'100%'}
                        >
                          <CustomButton
                            text='No Filter'
                            isOutline
                            bgColor={COLORS.BLACK_COLOR}
                            textColor={COLORS.BLACK_COLOR}
                            onPress={() => {
                              setOptions({ ...options, selected: '' });
                              setSelectedOption('general_' + activeTab);
                              setShowPopup(!showPopup);
                            }}
                          />
                          <CustomButton
                            text='Apply'
                            onPress={() => {
                              setSelectedOption(options.selected);
                              setShowPopup(!showPopup);
                            }}
                          />
                        </HStack>
                      }
                    />
                  </Box>
                ) : (
                  <div
                    onClick={() => setShowPopup(!showPopup)}
                    style={{ marginTop: '15px', marginRight: '8px' }}
                  >
                    <Svg
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      {filterSVG}
                    </Svg>
                    {showPopup && (
                      <MobileModelSheet
                        isOpen={showPopup}
                        onClose={() => setShowPopup(!showPopup)}
                        body={getPopupChildren()}
                        footer={
                          <HStack
                            mb={3}
                            justifyContent={'space-between'}
                            width={'100%'}
                          >
                            <CustomButton
                              text='No Filter'
                              isOutline
                              bgColor={COLORS.BLACK_COLOR}
                              textColor={COLORS.BLACK_COLOR}
                              onPress={() => {
                                setOptions({
                                  ...options,
                                  selected: ''
                                });
                                setSelectedOption('');
                                setShowPopup(!showPopup);
                              }}
                            />
                            <CustomButton
                              text='Apply'
                              onPress={() => {
                                setSelectedOption(options.selected);
                                setShowPopup(!showPopup);
                              }}
                            />
                          </HStack>
                        }
                      />
                    )}
                  </div>
                ))}

              <CommonAvatar
                width='50px'
                height='50px'
                bgcolor={COLORS.TABS_ACTIVE_BORDER_COLOR}
                svg={uploadWalletIconSVG}
                svgwh='24'
                view='0 0 22 22'
                onPress={openModal}
                touchable={true}
              />
            </HStack>
          </HStack>
        ) : selectedLink === 'DASHBOARD' ? (
          <HStack
            justifyContent={!MobileWindow && 'space-between'}
            alignItems={!MobileWindow && 'center'}
            direction={MobileWindow ? 'columns' : 'row'}
          >
            <Text
              fontSize={
                MobileWindow ? '22px' : COMMONFONTSIZE.HEADER_TEXT_FONT_SIZE
              }
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
            >
              Dashboard
            </Text>
            <HStack
              space={MobileWindow ? 1 : 5}
              alignItems={'center'}
            >
              <DateInputField
                name='from_date'
                onChange={onInputChange}
                defaultValue={
                  date.from_date === '' ? '2020-01-01' : date.from_date
                }
                label='Select From Date'
                fromDate={date.from_date && date.from_date}
                toDate={date.to_date && date.to_date}
                dashboard
                forceRemount={forceRemount}
              />
              <DateInputField
                name='to_date'
                onChange={onInputChange}
                defaultValue={date.to_date && date.to_date}
                label='Select To Date'
                fromDate={date.from_date && date.from_date}
                toDate={date.to_date && date.to_date}
                dashboard
                forceRemount={forceRemount}
              />
              <Box mt={5}>
                <CustomButton
                  height='40px'
                  text='Apply'
                  onPress={() => {
                    if (activeTab === 'event') ref.current.getEventsGraphsAPI();
                    else if (activeTab === 'mice') ref.current.getMICEGraphs();
                    ref.current.formatDateRange(date.from_date, date.to_date);
                  }}
                />
              </Box>
            </HStack>
          </HStack>
        ) : (
          <Box
            flexDirection='row'
            justifyContent={'space-between'}
            alignItems='center'
          >
            <Text
              fontSize={
                MobileWindow ? '22px' : COMMONFONTSIZE.HEADER_TEXT_FONT_SIZE
              }
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
            >
              {textTransform(selectedLink)}
            </Text>
            {selectedLink === 'TRAVEL_PARTNER' && hasPermission('TRAVEL_PARTNERS') && (
              <CommonAvatar
                width={MobileWindow ? '35px' : '50px'}
                height={MobileWindow ? '35px' : '50px'}
                bgcolor={COLORS.TABS_ACTIVE_BORDER_COLOR}
                svg={addIconSVG}
                svgwh='24'
                view='0 0 24 24'
                onPress={() => {
                  scrollToTop();
                  setShowPartnerModal(true);
                }}
                touchable={true}
              />
            )}
            {selectedLink === 'SURVEY_FORM' && (
              <HStack space={2}>
                <CommonAvatar
                  width={MobileWindow ? '35px' : '50px'}
                  height={MobileWindow ? '35px' : '50px'}
                  bgcolor="transparent"
                  svg={dashboardSVG}
                  svgwh='24'
                  view='0 0 24 24'
                  onPress={() => {
                    scrollToTop();
                    window.location.href = '/survey-form-responses';
                  }}
                  touchable={true}
                />
                <CommonAvatar
                  width={MobileWindow ? '35px' : '50px'}
                  height={MobileWindow ? '35px' : '50px'}
                  bgcolor={COLORS.TABS_ACTIVE_BORDER_COLOR}
                  svg={addIconSVG}
                  svgwh='24'
                  view='0 0 24 24'
                  onPress={() => {
                    scrollToTop();
                    setShowSurveyModal(true);
                  }}
                  touchable={true}
                />
              </HStack>
            )}
          </Box>
        )}
        {getDetailsChildren()}
      </VStack>
      {!MobileWindow ? (
        <CustomModal
          isOpen={showModal}
          onClose={closeModal}
          header={modalHeader}
          body={
            <TravelWallet
              selectedTravelValue={selectedValue}
              setSelectedValue={setSelectedValue}
              isEvent={activeTab === 'event'}
              forceRemount={forceRemount}
              ref={childref}
              showModal={showModal}
            />
          }
          footer={modalFooter}
        />
      ) : (
        <MobileModelSheet
          isOpen={showModal}
          onClose={closeModal}
          header={modalHeader}
          body={
            <TravelWallet
              selectedTravelValue={selectedValue}
              setSelectedValue={setSelectedValue}
              isEvent={activeTab === 'event'}
              forceRemount={forceRemount}
              ref={childref}
              showModal={showModal}
            />
          }
          footer={modalFooter}
        />
      )}
      <EventPartnerModal
        isOpen={showPartnerModal}
        onClose={() => setShowPartnerModal(false)}
        type={activeTab} // 'event' or 'mice' based on current tab
        onSubmit={handleTravelPartnerSubmit}
      />
      <SurveyFormModal
        isOpen={showSurveyModal}
        onClose={() => setShowSurveyModal(false)}
        editData={null}
        isEditing={false}
        activeTab={activeTab}
        onSuccess={() => {
          if (selectedLink === 'SURVEY_FORM') {
            setRefreshTrigger((prev) => prev + 1);
          }
        }}
      />
    </Box>
  );
};

export default QuickLinksDetailsPage;
